'use es6';

import { Record } from 'immutable';
export const AudienceSourceApp = {
  ADS: 'ADS',
  WORKFLOW: 'WORKFLOW'
};
export const AudienceSyncErrorReason = {
  RATE_LIMIT: 'RATE_LIMIT',
  ADVERTISER_NOT_WHITELISTED_FOR_CONTACT_LIST_AUDIENCES: 'ADVERTISER_NOT_WHITELISTED_FOR_CONTACT_LIST_AUDIENCES',
  AUDIENCE_SIZE_TOO_LOW: 'AUDIENCE_SIZE_TOO_LOW',
  TWO_FACTOR_AUTH_REQUIRED: 'TWO_FACTOR_AUTH_REQUIRED',
  BUSINESS_MANAGER_NOT_CONNECTED: 'BUSINESS_MANAGER_NOT_CONNECTED',
  USER_CANNOT_ACCESS_CONTACT_LIST_AUDIENCES: 'USER_CANNOT_ACCESS_CONTACT_LIST_AUDIENCES',
  UNKNOWN: 'UNKNOWN'
};
const DEFAULTS = {
  id: null,
  portalId: null,
  adAccountId: null,
  audienceId: null,
  createdAt: null,
  objectListId: null,
  companyListType: null,
  seedTargetingAudienceId: null,
  lastSyncedAt: null,
  adNetwork: null,
  audienceSource: null,
  audienceSourceApp: null,
  audienceSyncStatus: null,
  ownerId: null,
  deleted: null,
  stale: null,
  inaccessibleSince: null,
  pixelId: null,
  audienceRules: null,
  mirrorListId: null,
  mirrorAndSourceComparedAt: null,
  hidden: null,
  createdAutomatically: null,
  pageId: null,
  audienceSyncErrorReason: null
};
const TargetingAudienceRecord = Record(DEFAULTS);
export default TargetingAudienceRecord;